//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uuidv1 from 'uuid/v1';

export default {
  name: 'Brooks1914RegistrationTermsConditionsModal',
  components: { },
  props: ['survey', 'stepCompleted'],
  data() {
    return {
      open: false,
      id: uuidv1(),
      loading: false,
      tcAccepted: false,
    };
  },
  created() {
    this.$container.eventBus.on('closeModal', (id) => {
      if (id === this.id) {
        this.close();
      }
    });
  },
  methods: {
    async completeSurvey() {
      // ADD ref for save function of the survey
      this.$emit('update:stepCompleted', true)
      this.close();
    },
    launch() {
      this.open = true;
      this.$store.dispatch('pushModal', this.id);
    },
    close() {
      this.open = false;
      this.$store.dispatch('popModal');
    },
  },
};
